import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { StreamsEndpointIds } from 'root/src/shared/streams/stream.constants';
export const monitorDropsStreamsEndpoint = {
    [StreamsEndpointIds.MONITOR_DROPS_STREAMS]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
